"use client";

var __jsx = React.createElement;
import React, { createContext, useContext, useState, useMemo } from "react";
const CancellationsContext = /*#__PURE__*/createContext(null);
export const CancellationsProvider = _ref => {
  let {
    children
  } = _ref;
  const {
    0: info,
    1: setInfo
  } = useState();
  const flags = useMemo(() => {
    var _info$refundable, _info$cancellable, _info$taxes;
    return {
      isRefundable: (_info$refundable = info === null || info === void 0 ? void 0 : info.refundable) !== null && _info$refundable !== void 0 ? _info$refundable : false,
      isCancellable: (_info$cancellable = info === null || info === void 0 ? void 0 : info.cancellable) !== null && _info$cancellable !== void 0 ? _info$cancellable : false,
      hasTaxes: ((_info$taxes = info === null || info === void 0 ? void 0 : info.taxes) !== null && _info$taxes !== void 0 ? _info$taxes : []).length > 0,
      isCancelled: (info === null || info === void 0 ? void 0 : info.status) === "cancelled"
    };
  }, [info]);
  const value = useMemo(() => ({
    info,
    setInfo,
    flags
  }), [info, flags]);
  return __jsx(CancellationsContext.Provider, {
    value: value
  }, children);
};
export const useCancellations = () => {
  const context = useContext(CancellationsContext);
  if (!context) {
    throw new Error("useCancellations must be used within a CancellationsProvider");
  }
  return context;
};